import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class AnnouncementClient {
  static baseUrl = BASE_URL;

  static getAnnouncements(user, selectedMarket = null) {
    const market = selectedMarket !== null ? selectedMarket : user.market;
    const url = `${this.baseUrl}/announcements/${market}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static deleteAnnouncement(user, id) {
    const url = `${this.baseUrl}/announcements/${id}`;

    return axios
      .delete(url, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveAnnouncement(user, announcementObj) {
    const url = `${this.baseUrl}/announcements`;

    return axios
      .post(url, announcementObj, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static updateAnnouncement(user, announcementObj, id) {
    const url = `${this.baseUrl}/announcements/${id}`;

    return axios
      .put(url, announcementObj, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
